export default {
  theme: {},
};
